const drupalSettings = window.drupalSettings || {};

const searchBox = drupalSettings?.widgets?.searchBox || {};
const filters = drupalSettings?.widgets?.filters || {};

const isMultipleBookingEnabled = drupalSettings?.search?.isMultipleBookingEnabled || true;

const search = drupalSettings?.search || {};

export {
  searchBox,
  filters,
  isMultipleBookingEnabled,
  search,
};

export default drupalSettings;
